import { Tag } from 'antd';
import { assertNever } from 'Common/utils';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReaderStatus } from 'utils/apiClient/services/shorepay/types';

interface Props {
  status: ReaderStatus;
}

enum TagColor {
  Blue = '#0099FF',
  Green = '#2EC671',
  Gray = 'rgba(0, 0, 0, 0.04)',
}

const ReaderStatusTag: React.FC<Props> = ({ status }) => {
  switch (status) {
    case 'Active':
      return (
        <Tag color={TagColor.Green}>
          <FormattedMessage defaultMessage="Active" />
        </Tag>
      );
    case 'Ordered':
      return (
        <Tag color={TagColor.Blue}>
          <FormattedMessage defaultMessage="Ordered" />
        </Tag>
      );
    case 'Cancelled':
      return (
        <Tag color={TagColor.Gray}>
          <span css="color: rgba(0, 0, 0, .65)">
            <FormattedMessage defaultMessage="Cancelled" />
          </span>
        </Tag>
      );
    case 'Pending':
      return (
        <Tag color={TagColor.Blue}>
          <FormattedMessage defaultMessage="Pending" />
        </Tag>
      );
    case 'Shipped':
      return (
        <Tag color={TagColor.Blue}>
          <FormattedMessage defaultMessage="Shipped" />
        </Tag>
      );
    case 'Disabled':
      return (
        <Tag color={TagColor.Gray}>
          <span css="color: rgba(0, 0, 0, .65)">
            <FormattedMessage defaultMessage="Disabled" />
          </span>
        </Tag>
      );

    default:
      return assertNever(status);
  }
};

export default ReaderStatusTag;
